// src/pages/Hilfsmittel/VertragsrichtlinienPage.js

import React, { useEffect, useState } from 'react';
import {
    Box,
    Typography,
    Accordion,
    AccordionSummary,
    AccordionDetails,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { loadContracts } from '../../services/contractService';

const Vertragsrichtlinien = () => {
    const [hmvList, setHmvList] = useState([]);

    useEffect(() => {
        const contracts = loadContracts();
        const list = [];
        contracts.forEach(c => {
            if (c.preisdetails) {
                Object.entries(c.preisdetails).forEach(([nr, detail]) => {
                    list.push({ nummer: nr, ...detail });
                });
            }
        });
        setHmvList(list);
    }, []);

    return (
        <Box sx={{ maxWidth: 800, mx: 'auto', mt: 4 }}>
            <Typography variant="h5" gutterBottom>
                Gespeicherte Richtlinien
            </Typography>
            {hmvList.map((hmv, idx) => (
                <Accordion key={idx}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}> 
                        <Typography>{hmv.nummer}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography>Preis: {hmv.preis} €</Typography>
                        <Typography>Typ: {hmv.typ}</Typography>
                        <Typography>
                            Genehmigungspflichtig: {hmv.genehmigungspflichtig ? 'Ja' : 'Nein'}
                        </Typography>
                    </AccordionDetails>
                </Accordion>
            ))}
            {hmvList.length === 0 && (
                <Typography variant="body2">Keine gespeicherten Verträge gefunden.</Typography>
            )}
        </Box>
    );
};

export default Vertragsrichtlinien;
